import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export function TryNowRedirect() {
    const [searchParams, setSearchParams] = useSearchParams();
    const token = searchParams.get("tryNowToken");
    const expires = searchParams.get("tryNowTokenExpires");
    const redirect = searchParams.get("redirect");

    useEffect(() => {
        window.localStorage.setItem("tryNowToken", token || "");
        window.localStorage.setItem("tryNowTokenExpires", expires || "");
        window.location.replace(redirect || "/");
    }, [searchParams]);

    return <main className="redirecting">
        <p>Redirecting...</p>
    </main>;
}
